/**
 * The trip catalogue guests may browse without an account: Explora and the trip pages.
 * Plain patterns rather than a router's matcher so the rule works on any client (web router paths
 * and the mobile app's Expo Router paths share the same URL shape). Case-insensitive and tolerant
 * of one trailing slash, like react-router's `matchPath` defaults.
 */
const PUBLIC_CATALOG = [/^\/explorar\/?$/i, /^\/explorar\/[^/]+\/?$/i, /^\/viajes\/[^/]+\/?$/i];

export function isPublicCatalogPath(pathname: string): boolean {
  // The personalized-trip form sits under /viajes but is a customer request, not the catalogue.
  if (/^\/viajes\/a-la-medida\/?$/i.test(pathname)) return false;
  return PUBLIC_CATALOG.some((pattern) => pattern.test(pathname));
}
